import { useStyles } from 'tss-react';
import { Typography } from '@mui/material';

interface SearchTableListHeaderProps {
  classes: {
    columns: string;
    header: string;
  };
  columns: {
    name: boolean;
    description: boolean;
    actions: boolean;
  };
  selectionModeEnabled: boolean; // maybe in context
}

const SearchTableListHeader: React.FC<SearchTableListHeaderProps> = ({
  classes,
  columns
}) => {
  const { cx } = useStyles();
  return (
    <div className={cx(classes.header, classes.columns)}>
      <div></div>
      <Typography variant="h5">Ingredient</Typography>
      {columns.description && <Typography variant="h5">Description</Typography>}
      <Typography variant="h5" className="text-end">
        Actions
      </Typography>
    </div>
  );
};

export default SearchTableListHeader;
